import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import Tooltip from 'chameleon/packages/blue-book-player/library/tooltip';

const ModalTitle = (props) => {
  const { modalUUID, title, className, hasTitleWithTooltip } = props;
  const tooltipRef = useRef();
  const spanTitleRef = useRef();
  const headingRef = useRef();

  const renderTitleToolTip = (_title) => (
    <Tooltip
      ref={tooltipRef}
      containerTagElement="span"
      containerClassName="inline"
      description={_title}
      target="modal-title"
    >
      <span id="modal-title">{_title}</span>
    </Tooltip>
  );
  const renderTitle = (_title) => <span ref={spanTitleRef}>{_title}</span>;
  const [computedTitle, setComputedTitle] = useState(null);

  useEffect(() => {
    const titleRef = spanTitleRef.current;
    if (
      hasTitleWithTooltip &&
      titleRef &&
      titleRef.offsetWidth > headingRef.current.offsetWidth
    ) {
      setComputedTitle(renderTitleToolTip(title));
    } else {
      setComputedTitle(renderTitle(title));
    }
  }, [title, hasTitleWithTooltip]);

  return (
    <h2
      ref={headingRef}
      id={`modal-title--${modalUUID}`}
      className={cn(
        className,
        'text-default font-medium leading-normal truncate',
      )}
      data-test-id="modal-title"
    >
      {computedTitle}
    </h2>
  );
};

ModalTitle.propTypes = {
  title: PropTypes.any,
};

ModalTitle.defaultProps = {
  title: '',
};

export default ModalTitle;
